import Highcharts from "./customHighCharts";

// This function first ensures that no color has been defined in the chart parameters
// before replacing HighChart's default blue color with Jenparle's blue color
export const applyCustomColors = customColor => {
  // We check if custom colors have been set by using the customColorsSet flag added
  // from the HighchartsConfigController. If so, we should leave them as they are.
  const defaultColors = Highcharts.getOptions().colors;

  if (Highcharts.customColorsSet) {
    return defaultColors;
  }

  // If a custom color is provided, replace the first color in the palette
  // (often blue) with our `$blue-light`
  if (customColor) {
    const customColors = [...defaultColors];
    customColors[0] = customColor;
    return customColors;
  }

  // If no custom color is provided, we return the default Highcharts palette
  return defaultColors;
};
